export const ROLE_RULES = {
  Owner: ["Super Admin", "Admin", "Standard User"],
  "Super Admin": ["Super Admin", "Admin", "Standard User"],
  Admin: ["Admin", "Standard User"],
  "Standard User": [],
};
